export const EVENT_FILTERS = [
  { id: 'all', name: 'Все' },
  { id: 'true', name: 'Активные' },
  { id: 'false', name: 'Забаненные' },
];

export const EVENT_WIDTHS = [4, 42, 23, 23, 3]; // margin right

export const EVENT_HEADER_COLUMNS = [
  { text: '№', width: EVENT_WIDTHS[0] },
  { text: 'Название мероприятия', width: EVENT_WIDTHS[1] },
  { text: 'ID мероприятия', width: EVENT_WIDTHS[2] },
  { text: 'ID владельца', width: EVENT_WIDTHS[3] },
  { text: '', width: EVENT_WIDTHS[4] }];

export const EVENT_MODAL_STATES = {
  block: 'block',
  makeActive: 'makeActive',
  changeData: 'changeData',
  fullyDelete: 'fullyDelete',
};
